import React from 'react';

interface LoaderProps {
  isConnecting: boolean;
  isMuted: boolean;
  isConnected: boolean;
}

const Loader: React.FC<LoaderProps> = ({
  isConnecting,
  isMuted,
  isConnected,
}) => {
  return (
    <div
      className={`absolute inset-0 opacity-80 rounded-full z-10 border-4 flex items-center justify-center ${
        isConnecting
          ? 'border-transparent'
          : isConnected && !isMuted
          ? 'border-[#C0C0C0]'
          : 'border-[#EC3E41]'
      }`}>
      {isConnecting && (
        <svg
          className="absolute top-0 left-0 w-40 h-40 -ml-1 -mt-1 animate-loader-rotate origin-center"
          viewBox="25 25 50 50"
          preserveAspectRatio="xMidYMid meet">
          <circle
            className="animate-loader-dash stroke-loader stroke-round"
            cx="50"
            cy="50"
            r="24"
            fill="none"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </svg>
      )}
    </div>
  );
};

export default Loader;
